<script>
	import formBase from '@_system/components/base/form.vue'
	import supplieraccountbox from './box/supplieraccount.vue'
	import detailIndex from './detail/index.vue'
	import printIndex from './print/index.vue'
	import tradeBox from './box/tradebox.vue'
	export default {
		extends: formBase,
		name: 'paymentapplicationForm',
		render(h) {
			this.$slots.plug = [
				<supplieraccountbox ref="supplieraccountbox" supplierwlnid={this.supplierwlnid} onSubmit={this.supplieraccountSubmit}  />,
				<trade-box ref="tradeBox"  />,
				<detailIndex ref="detailIndex" tableData={this.detailData}   />,
				<vxe-modal v-model={this.printShow} title="打印" width="1000" height="700" show-footer
					transfer show-close destroy-on-close>
					<print-index formdata={this.formdata} />
				</vxe-modal>	
			]
			return formBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				type:'CD',
				formToolbarConfig: [{
						group: 'file',
						code: 'print',
						title: '打印付款申请书',
						disabled: false
					}
				],
				formdata:null,
				printShow:false,
				detailData:[],
				supplierwlnid: null,
				settlementtype: 0,
				shopid_system:null,
				monthpaymentordertitle:'付款单',
				monthpaymentordertype:'FK',
				exchangepaymentordertitle:'售后单',
				exchangepaymentordertype:'SH',
				invoiceList:[]
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			toolbarClick(e) {
				if (e == 'print') {
					this.printShow = true
					this.formdata = this.fApi.form
				}
			},
			beforeInit(next) {
				this.type = 'CD'
				if(this.extra.customertype=='monthpayment'){
					this.type = 'FK'
				}
				if(this.extra.customertype=='exchangepayment'){
					this.type = 'SH'
				}
				if (this.extra.customertype == 'monthpayment'){
					if(this.id==0){
						this.$confirm('单据类型', '请选择', {
							confirmButtonText: '付款单',
							cancelButtonText: '预付款单',
							type: 'warning',
							closeOnPressEscape:false,
							closeOnClickModal:false,
							showClose:false
						}).then(() => {
							this.monthpaymentordertype = 'FK'
							this.monthpaymentordertitle = '付款单'
							next()
						}).catch(()=>{
							this.monthpaymentordertype = 'YFK'
							this.monthpaymentordertitle = '预付款单'
							next()
						})
					}else{					
						next()
					}
				}else{
					next()
				}
				
				//next()
				
				// else if(this.extra.customertype == 'exchangepayment'){
				// 	this.$confirm('是否发货', '请选择', {
				// 		confirmButtonText: '已发货【选择SH单】',
				// 		cancelButtonText: '未发货【选择XD单】',
				// 		type: 'warning',
				// 		closeOnPressEscape:false,
				// 		closeOnClickModal:false,
				// 		showClose:false
				// 	}).then(() => {
				// 		this.exchangepaymentordertype = 'SH'
				// 		this.exchangepaymentordertitle = '售后单'
				// 		next()
				// 	}).catch(()=>{
				// 		this.exchangepaymentordertype = 'XDSH'
				// 		this.exchangepaymentordertitle = '仅退款销售单'
				// 		next()
				// 	})
				// }else{
				// 	next()
				// }
				
				
				//console.log(this.extra)
				// if(this.extra.billCode){
				// 	this.$api.reconciliationcurrent.list({
				// 		mode:'box',
				// 		index:0,
				// 		purchasecode:this.extra.billCode,
				// 		ordertype:'CD',
				// 	}).then((res)=>{					
				// 		if(res.list.length && res.list[0].settlementtype == 8806){
				// 			this.$message.error('月结客户请发起月结排期申请')
				// 			return
				// 		}
				// 		next()
				// 	})
				// }else{
				// 	next()
				// }
				
			},
			beforeFormCreate(res){
				res.forEach((item)=>{
					if(item.field =='license' || item.field =='entrust' || item.field =='contract' || item.field =='invoicefile'){
						if(!(this.sourceData && this.sourceData.hasinvoice==5)){
							item.hidden = true
						}else{
							item.hidden = false
						}
					}
					if(this.exchangepaymentordertype == 'XDSH'){
						if(item.field =='purchasecode'){
							item.type = '$inputButton'
						}
					}
					if (this.extra.customertype == 'exchangepayment') {
						if(item.field =='purchasecode'){
							item.props.button.props.index = 1
						}
						if(item.field =='rcvAcc'){
							item.type = ''
						}
					}
				})				
			},
			beforeSubmit(formData, next) {		
				//console.log(formData, next)
				
				formData.detail_system = this.detailData
				formData.purchasesum = this.computeAmount()
				formData.shopid_system = this.shopid_system
				if(this.fApi.getValue('ordertype') == 'SH'){
					if(!this.fApi.getValue('bankAcc').includes('@')){
						if(!this.fApi.getValue('rcvBankName')){
							this.$message.error('对公转账开户行必填')
						}else{
							next()
						}
					}else{
						next()
					}
				}else{
					console.log(formData)
					next()
				}
			},
			regestEvent() {
				let purchasecode = this.fApi.el('purchasecode')
				if (purchasecode.store && purchasecode.store.box) {
					//console.log(this.extra)
					if (this.extra.customertype == 'monthpayment') {
						this.fApi.setValue('ordertype', 'FK')
						let reconciliationbillid = this.sourceData?this.sourceData.reconciliationbillid:null
						purchasecode.store.box[0].boxtitle = '付款单'
						purchasecode.store.box[0].setForeingKey({
							ordertype: this.monthpaymentordertype,
							reconciliationbillid:reconciliationbillid?reconciliationbillid:null
						})
						console.log(purchasecode.store.box[0])
					}else if(this.extra.customertype == 'exchangepayment'){
						this.fApi.setValue('ordertype', 'SH')
						purchasecode.store.box[0].boxtitle = this.exchangepaymentordertitle
						purchasecode.store.box[0].setForeingKey({
							ordertype: this.exchangepaymentordertype,
						})
						if(this.extra.billCode){
							this.$api.reconciliationcurrent.list({
								mode:'box',
								index:0,
								purchasecode:this.extra.billCode,
								ordertype:'SH',
							}).then((res)=>{
								if(res.list.length){
									let param = {
										moduleName:'reconciliationcurrent',
										data:res.list[0]
									}
									this.setQuoteData(param)
									this.afterBoxSubmit(param)
								}
							})
						}
					}else{
						purchasecode.store.box[0].setForeingKey({
							ordertype: 'CD',
						})
						purchasecode.store.box[0].checkMethod = ({
							row
						}) => {
							return row.settlementtype != 8806
						}
						if(this.extra.billCode){
							this.fApi.setValue('purchasecode', this.extra.billCode)
							this.fApi.setValue('supplierwlnid', this.extra.supplierID)
							this.fApi.setValue('supplier', this.extra.supplierName)
							this.$api.reconciliationcurrent.list({
								mode: 'box',
								index: 0,
								ordertype:'CD',
								purchasecode:this.extra.billCode
							}).then((res) => {
								if(res.list.length){
									let param = {
										moduleName:'reconciliationcurrent',
										data:res.list[0]
									}
									this.setQuoteData(param)
									this.afterBoxSubmit(param)
								}
							})
						}
					}
				}else{
					if(this.extra.customertype == 'exchangepayment'){
						this.fApi.setValue('ordertype', 'SH')
					}
				}
			},
			afterGet(e){
				this.detailData = e.detail_system
			},
			afterBoxSubmit(e) {
				if (e.moduleName == 'reconciliationcurrent') {
					let type = 'CD'
					if(this.extra.customertype=='monthpayment'){
						type = 'FK'
					}
					if(this.extra.customertype=='exchangepayment'){
						type = 'SH'
					}	
					this.clearAccount()			
								
					this.fApi.setValue('purchasetime', e.data.purchasebiztime * 1000)
					this.fApi.setValue('relationorder', null)
					this.loading = true
					this.settlementtype = e.data.settlementtype
					let purchasecode = e.data.purchasecode
					let purchasebiztime = e.data.purchasebiztime
					this.fApi.setValue('ordertype', type)
					this.$api.paymentapplication.grabbipurchase({
						supplierwlnid: e.data.purchasesupplierid,
						purchasecode: purchasecode,
						purchasebiztime: purchasebiztime,
						type: type=='FK'?this.monthpaymentordertype:type
					}).then((res) => {
						this.detailData = res.detail
						let sum = 0
						if (type == 'CD') {
							sum = res.sum
						} else if(type=='FK'){
							sum = res.fbil_sum
						}else{
							sum = res.amount
						}
						this.fApi.setValue('prepaymenttime', this.getPrePaymenttime(e.data, sum))
						this.fApi.setValue('purchasesum', sum)
						this.fApi.setValue('orderamount', sum)					
						this.loading = false						
						if(type=='CD'){
							this.fApi.setValue('systemcost', res.systemcost)
							this.fApi.setValue('diffcost', ((sum - res.systemcost)/res.systemcost * 100).toFixed(2))
							this.fApi.setValue('invoicetype', res.invoicetype)
							this.fApi.setValue('accountbusiness', res.accountbusiness)
							this.fApi.setValue('supplierbelongstaffid', e.data.busnessstaffid)
							//this.getRcvmentAccount()
						}
						if(type=='FK'){
							this.fApi.setValue('purchasesum', e.data.purchasesum)
							this.fApi.setValue('paymenttype', e.data.paymenttype)
							this.fApi.setValue('preferential', e.data.preferential)
							this.fApi.setValue('tax', e.data.tax)
							this.fApi.setValue('hasinvoice', e.data.hasinvoice)
							this.fApi.setValue('checkstaffid', e.data.checkstaffid)
							this.fApi.setValue('invoicetype', res.invoicetype)
							this.fApi.setValue('accountbusiness', res.accountbusiness)
							this.fApi.setValue('supplierbelongstaffid', e.data.busnessstaffid)							
							this.getRcvmentAccount()
							
						}
						if(type=='SH'){
							this.shopid_system = e.data.sys_shop
							this.fApi.setValue('relationorder', e.data.trade_no)
							this.fApi.setValue('showName', e.data.showName)
							this.fApi.setValue('originstorage', e.data.originstorage)
							this.fApi.setValue('refundstage', e.data.refundstage)
							this.fApi.setValue('exchangetype', e.data.exchange_type)
							this.fApi.setValue('relationordermark', e.data.tradeRemark)
							let img_file = []
							for(let i=1;i<4;i++){
								let imgurl = e.data['pic'+i]
								if(!imgurl){
									continue
								}
								imgurl = imgurl.split('/')
								img_file.push({
									uid:i,
									url:e.data['pic'+i],
									name:imgurl[imgurl.length-1],
									path:e.data['pic'+i],
									type:'PNG',
									status:'success',
								})								
							}
							this.fApi.setValue('img_file', img_file)
							// console.log(e.data)
							if(e.data.receive_account){
								let receiveaccount = e.data.receive_account.split('|')
								this.$nextTick(()=>{
									this.fApi.setValue('rcvAcc', receiveaccount[0]?receiveaccount[0]:null)
									this.fApi.setValue('rcvName', receiveaccount[1]?receiveaccount[1]:null)
								})
							}
							// if(this.extra.receiveaccount){
							// 	let receiveaccount = this.extra.receiveaccount.split('|')
							// 	this.$nextTick(()=>{
							// 		this.fApi.setValue('rcvAcc', receiveaccount[0]?receiveaccount[0]:null)
							// 		this.fApi.setValue('rcvName', receiveaccount[1]?receiveaccount[1]:null)
							// 	})
							// }
							
							this.getPaymentAccount()
							this.getInvoiceInfo()
						}
						//

					}, () => {
						this.fApi.setValue('purchasesum', 0)
						this.fApi.setValue('orderamount', 0)
						this.loading = false
					})

				}
			},
			purchasecodeButton(){
				this.$refs.tradeBox.initList()
				this.$refs.tradeBox.box.alertBox()
			},
			paytypeChange(e){
				this.clearAccount()
				if(e != 1){
					this.clearAccount()
					this.getPaymentAccount()
				}
				
			},
			getPrePaymenttime(data, sum) {
				let time = null
				let type = this.extra.customertype == 'monthpayment' ? 'FK' : 'CD'
				if (type == 'CD') {
					time = new Date().getTime()
				}
				if (type == 'FK') {
					console.log(data, sum)
					if (data.paymentlevel == 8924) {
						time = this.getNextMonthDateTimestamp(10,0,'month')
					}
					if (data.paymentlevel == 8925) {
						if(sum<=20000){
							time = this.getNextMonthDateTimestamp(18,0,'month')
						}else if(sum<=40000){
							time = this.getNextMonthDateTimestamp(19,0,'month')
						}else if(sum<=60000){
							time = this.getNextMonthDateTimestamp(20,0,'month')
						}else if(sum<=80000){
							time = this.getNextMonthDateTimestamp(21,0,'month')
						}else if(sum<=100000){
							time = this.getNextMonthDateTimestamp(22,0,'month')
						}else{
							time = this.getNextMonthDateTimestamp(23,0,'month')
						}
						
					}
					if (data.paymentlevel == 8926) {
						if(sum<=20000){
							time = this.getNextMonthDateTimestamp(18,0,'quarter')
						}else if(sum<=40000){
							time = this.getNextMonthDateTimestamp(19,0,'quarter')
						}else if(sum<=60000){
							time = this.getNextMonthDateTimestamp(20,0,'quarter')
						}else if(sum<=80000){
							time = this.getNextMonthDateTimestamp(21,0,'quarter')
						}else if(sum<=100000){
							time = this.getNextMonthDateTimestamp(22,0,'quarter')
						}else{
							time = this.getNextMonthDateTimestamp(23,0,'quarter')
						}
					}
					if (data.paymentlevel == 8927) {
						if(sum<=20000){
							time = this.getNextMonthDateTimestamp(18,0,'half-year')
						}else if(sum<=40000){
							time = this.getNextMonthDateTimestamp(19,0,'half-year')
						}else if(sum<=60000){
							time = this.getNextMonthDateTimestamp(20,0,'half-year')
						}else if(sum<=80000){
							time = this.getNextMonthDateTimestamp(21,0,'half-year')
						}else if(sum<=100000){
							time = this.getNextMonthDateTimestamp(22,0,'half-year')
						}else{
							time = this.getNextMonthDateTimestamp(23,0,'half-year')
						}
					}
					if (data.paymentlevel == 8928) {
						if(sum<=20000){
							time = this.getNextMonthDateTimestamp(18,1,'year')
						}else if(sum<=40000){
							time = this.getNextMonthDateTimestamp(19,1,'year')
						}else if(sum<=60000){
							time = this.getNextMonthDateTimestamp(20,1,'year')
						}else if(sum<=80000){
							time = this.getNextMonthDateTimestamp(21,1,'year')
						}else if(sum<=100000){
							time = this.getNextMonthDateTimestamp(22,1,'year')
						}else{
							time = this.getNextMonthDateTimestamp(23,1,'year')
						}
					}
					if (data.paymentlevel == 8929) {
						return time
					}
				}
				return time
			},
			getRcvmentAccount(){
				let wlnid = this.fApi.getValue('supplierwlnid')
				this.$api.supplier.getAccountByWlnid(wlnid,{
					mode: 'box',
					index: 0,
					currentPage:-1
				}).then((res) => {
					let data = null
					if(res.length){
						if(res.length == 1){
							data = res
						}else{
							data = res.filter((item)=>{
								return item.isfirst == 5
							})
							if(!data.length){
								data = res.filter((item)=>{
									return item.accountbusiness == 8921
								})
							}
						}
					}
					if(data.length){			
						this.supplieraccountSubmit({data:data[0]})
					}else{
						this.$message.error('未查询到供应商【对公】收款账号')
					}
					
					
				})
			},
			redoutputinvoicecodeChange(e){
				let target = this.invoiceList.find((item)=>{
					return item.invoicecode == e
				})
				if(target){
					this.fApi.setValue('redoutputinvoiceamount',target.invoiceamountwithtax)
				}else{
					this.fApi.setValue('redoutputinvoiceamount',null)
				}
			},
			getInvoiceInfo() {
				if(this.type == 'SH'){
					this.loading = true
					this.$api.paymentapplication.getInvoiceInfo({
						relationorder:this.fApi.getValue('relationorder')
					}).then((res) => {
						this.invoiceList = res.data
						let redoutputinvoicecode = this.fApi.el('redoutputinvoicecode')
						redoutputinvoicecode.options = res.reddata.map((item)=>{
							return {
								label:item.invoicecode,
								value:item.invoicecode,
							}
						})
						if(res.data.length || res.outboundlist.invoiceCode.length){
							this.fApi.setValue('hasinvoice',5)
						}else{
							this.fApi.setValue('hasinvoice',6)
						}
						let grossProfit = res.outboundlist.grossProfit - res.outboundlist.taxsum
						if(res.outboundlist.saleSum){
							this.fApi.setValue('profit',Math.round(grossProfit/res.outboundlist.saleSum * 100,2))
							this.fApi.setValue('outboundorder',res.outboundlist.XCCode.join(','))
						}
						this.loading = false
					}, () => {
						this.loading = false
					})
				}

			},
			getPaymentAccount(data) {
				let obj = {}
				let type = 'CD'
				if(this.extra.customertype=='monthpayment'){
					type = 'FK'
				}
				if(this.extra.customertype=='exchangepayment'){
					type = 'SH'
				}	
				if(data){
					obj = {
						purchasesum: this.fApi.getValue('purchasesum'),
						accountbusiness: data.accountbusiness,
						payaccount: data.payaccount,
						type: type,
					}
				}else{
					obj = {
						relationorder: this.fApi.getValue('relationorder'),
						type: type
					}
				}
				obj.isrefund = this.fApi.getValue('isrefund')
				obj.paytype =  this.fApi.getValue('paytype')
				this.loading = true
				this.$api.paymentapplication.getPaymentAccount(obj).then((res) => {
					this.fApi.setValue('corpCode', res.corpCode)
					this.fApi.setValue('accName', res.accName)
					this.fApi.setValue('bankAcc', res.bankAcc)
					this.fApi.setValue('availBal', res.availBal)
					this.fApi.setValue('transSequenceIdn', res.transSequenceIdn)
					this.fApi.setValue('payaccountbusiness', res.accountbusiness)
					if(!res.corpCode){
						this.fApi.setValue('isauto', 6)
					}else{
						this.fApi.setValue('isauto', 5)
					}
					// if(type=='SH'){
					// 	this.fApi.setValue('rcvName', res.rcvName)
					// }					
					this.loading = false
				}, () => {
					this.fApi.setValue('corpCode', null)
					this.fApi.setValue('accName', null)
					this.fApi.setValue('bankAcc', null)
					this.fApi.setValue('availBal', null)
					this.fApi.setValue('transSequenceIdn', null)
					this.fApi.setValue('payaccountbusiness', null)
					this.fApi.setValue('isauto', null)
					// if(type=='SH'){
					// 	this.fApi.setValue('rcvName', null)
					// }	
					this.loading = false
				})
			},
			clearAccount(){
				this.fApi.setValue('rcvAcc', null)
				this.fApi.setValue('rcvBankName', null)
				this.fApi.setValue('rcvName', null)
				this.fApi.setValue('rcvaccountbusiness', null)
				this.fApi.setValue('corpCode', null)
				this.fApi.setValue('accName', null)
				this.fApi.setValue('bankAcc', null)
				this.fApi.setValue('availBal', null)
				this.fApi.setValue('payaccountbusiness', null)
			},
			supplieraccountSubmit(e) {
				let data = e.data
				this.fApi.setValue('rcvAcc', data.rcvAcc)
				this.fApi.setValue('rcvBankName', data.rcvBankName)
				this.fApi.setValue('rcvName', data.rcvName)
				this.fApi.setValue('rcvaccountbusiness', data.accountbusiness)
				this.getPaymentAccount(data)
			},
			rcvAccButton() {
				let type = this.extra.customertype == 'monthpayment' ? 'FK' : 'CD'
				this.supplierwlnid = this.fApi.getValue('supplierwlnid')
				if (this.supplierwlnid) {
					this.$refs.supplieraccountbox.foreingKey = {
						ordertype: type
					}
					this.$refs.supplieraccountbox.initList()
					this.$refs.supplieraccountbox.box.alertBox()

				} else {
					this.$message.error('请选择供应商')
				}
			},
			payaccountbusinessChange(e){
				if(this.type!='SH'){
					if(e == 8921){
						this.fApi.setValue('hasinvoice', 5)
					}else{
						this.fApi.setValue('hasinvoice', 6)
					}
				}

			},
			invoicefileChange(e){
				if(e.length!=0){
					this.$api.paymentapplication.ocrinvoice({invoicefilepath:e[0].path}).then((res)=>{
						console.log(res)
					})
				}

	
			},
			hasinvoiceChange(e){	
				let type = 'CD'
				if(this.extra.customertype=='monthpayment'){
					type = 'FK'
				}
				if(this.extra.customertype=='exchangepayment'){
					type = 'SH'
				}
				if(type!='SH'){
					if(e==5){
						this.fApi.mergeRule('license', {
							hidden: false ,
							validate:{
								required: true,
								message: "缺少营业执照"
							}
						})
						this.fApi.mergeRule('entrust', {
							hidden: false 
						})
						this.fApi.mergeRule('contract', { hidden: false })
						this.fApi.mergeRule('invoicefile', { hidden: false })
						this.fApi.mergeRule('invoiceno', { hidden: false })
						this.fApi.mergeRule('invoicetime', { hidden: false })
						this.fApi.mergeRule('invoicebuyer', { hidden: false })
						this.fApi.mergeRule('invoicesaler', { hidden: false })
						this.fApi.mergeRule('invoicepricewithtax', { hidden: false })
						let wlnid = this.fApi.getValue('supplierwlnid')
						if(wlnid){
							this.$api.paymentapplication.getsupplierlicense({wlnid:wlnid}).then((res)=>{
								if(res){
									this.fApi.setValue('license',res.license)
									this.fApi.setValue('entrust',res.entrust)
									// if(!this.fApi.getValue('license')){
									// 	this.fApi.setValue('license',res.license)
									// }
									// if(!this.fApi.getValue('entrust')){
									// 	this.fApi.setValue('entrust',res.entrust)
									// }
									
								}
							})
						}
					}else{
						this.fApi.mergeRule('license', { 
							hidden: true ,
							validate:{
								required: false,
									message: "必填项"
								}
						})
						this.fApi.mergeRule('entrust', {
							hidden: true 
						})
						this.fApi.mergeRule('contract', { hidden: true })
						this.fApi.mergeRule('invoicefile', { hidden: true })
						this.fApi.mergeRule('invoiceno', { hidden: true })
						this.fApi.mergeRule('invoicetime', { hidden: true })
						this.fApi.mergeRule('invoicebuyer', { hidden: true })
						this.fApi.mergeRule('invoicesaler', { hidden: true })
						this.fApi.mergeRule('invoicepricewithtax', { hidden: true })
					}
				}

				//console.log(e)
			},
			preferentialChange() {
				let purchasesum = this.computeAmount()
				this.fApi.setValue('purchasesum', purchasesum.toFixed(2))
			},
			taxChange() {
				let purchasesum = this.computeAmount()
				this.fApi.setValue('purchasesum', purchasesum.toFixed(2))
			},
			purchasesumChange(){
				if(this.id==0){
					this.clearAccount()
				}
			},
			isrefundChange() {
				this.getPaymentAccount()
			},
			computeAmount() {
				let orderamount = this.fApi.getValue('orderamount')
				let preferential = this.fApi.getValue('preferential')
				let tax = this.fApi.getValue('tax')
				orderamount = orderamount ? parseFloat(orderamount) : 0
				preferential = preferential ? parseFloat(preferential) : 0
				tax = tax ? parseFloat(tax) : 0
				let purchasesum = orderamount - preferential + tax
				//this.fApi.setValue('purchasesum', purchasesum.toFixed(2))
				return purchasesum
			},
			getNextMonthDateTimestamp(day, valueAhead, periodType) {
				const now = new Date()
				const currentYear = now.getFullYear();
				const currentMonth = now.getMonth();
				const currentDate = now.getDate();
				let targetYear = currentYear;
				let targetMonth;
				let targetDate;	
				let targetQuarter;
				let currentQuarter;
				switch (periodType) {
					case 'day':
						targetDate = new Date(now);
						targetDate.setDate(now.getDate() + valueAhead);
						break;
					case 'month':
						targetMonth = currentMonth + valueAhead;
						targetYear += Math.floor(targetMonth / 12);
						targetMonth %= 12;
						targetDate = new Date(targetYear, targetMonth, day);
						break;
					case 'quarter':
						currentQuarter = Math.floor(currentMonth / 3);
						targetQuarter = currentQuarter + valueAhead;
						if (valueAhead === 0) {
							targetQuarter = currentQuarter;
						}
						targetYear += Math.floor(targetQuarter / 4);
						targetMonth = (targetQuarter % 4) * 3 + 3; // 4,7,10,1 (次年1月)
						targetDate = new Date(targetYear, targetMonth, day);
						break;
					case 'half-year':
						targetMonth = 6; // 当前年份的7月
						targetDate = new Date(targetYear, targetMonth, day);
						break;
					case 'year':
						targetYear += valueAhead;
						targetMonth = 0; // 明年1月
						targetDate = new Date(targetYear, targetMonth, day);
						break;	
					default:
						throw new Error('Invalid periodType. Use "day", "month", "quarter", or "half-year".');
						
				}

				// 设置目标日期的天
				targetDate.setDate(day);

				// 如果指定日期是周日，则顺延一天
				if (targetDate.getDay() === 0) {
					targetDate.setDate(targetDate.getDate() + 1);
				}
				// 如果计算的日期小于或等于当前时间，则返回明天的时间戳
				if (targetDate <= now) {
					targetDate = new Date(now);
					targetDate.setDate(currentDate + 1);

					// 如果明天是周日，则顺延一天
					if (targetDate.getDay() === 0) {
						targetDate.setDate(targetDate.getDate() + 1);
					}
				}
				// 获取时间戳
				const timestamp = targetDate.getTime();
				return timestamp;
			},
			
			diffcostButton(){

				this.$refs.detailIndex.modalShow()
			},			
			
			checkrpice(){
				
			}

		},
		components: {
			supplieraccountbox,
			detailIndex,
			tradeBox,
			printIndex
		}
	}
</script>